<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  commissionLabel: { type: String, required: true },
  installmentLabel: { type: String, required: true },
  totalLabel: { type: String, required: true },
});

const { t } = useI18n();
</script>

<template>
  <div class="flex flex-wrap items-center justify-between gap-2">
    <span
      v-tooltip.top="
        t('REAL_ESTATE_FINANCE.PAYERS_FORM.COMMISSION_TOOLTIP', {
          value: commissionLabel,
        })
      "
      class="rounded-full bg-orange-100 px-3 py-1 text-sm font-semibold text-orange-800"
    >
      {{
        t('REAL_ESTATE_FINANCE.PAYERS_FORM.INSTALLMENT_VALUE', {
          value: installmentLabel,
        })
      }}
    </span>
    <span class="text-sm text-lais-text-muted">
      {{
        t('REAL_ESTATE_FINANCE.PAYERS_FORM.TOTAL_VALUE', {
          value: totalLabel,
        })
      }}
    </span>
  </div>
</template>
